import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../common/js/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {DateAxis, LabelBullet} from "@amcharts/amcharts4/charts";

declare var ko: any;

export class leadgen_template extends vnTemplate {

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    protected verticalFilter : multipleSelector_template;
    protected productFilter : multipleSelector_template;
    protected partnerFilter : multipleSelector_template;
    protected campaignFilter : multipleSelector_template;
    protected campaignLabelFilter : multipleSelector_template;
    protected adGroupFilter : multipleSelector_template;
    protected formVariantFilter : multipleSelector_template;
    protected stateFilter : multipleSelector_template;
    protected distributionChannelFilter : multipleSelector_template;
    protected leadBuyerFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    protected exportDataCsv: exportDataCsv;
    protected allVerticalOptions: Array<any> = [];
    protected productOptionsByVertical: {[key: string]: Array<any>} = {};
    protected allCampaignGroups: Array<any> = [];

private leadgenCharts: Record<string, am4charts.XYChart> = {};


    protected getTemplateName(): string {

        return "leadgen_template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content", "leadgen"];
    }

    protected initPartial(): void {
        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('leadgen');

        this.verticalFilter = new multipleSelector_template("verticalFilter", this.getTemplateViewModel(), this.caller);
        this.verticalFilter.setLabel("Vertical");
        this.verticalFilter.setFilterContainerClass('margin-neg');
        this.verticalFilter.setTagContainerId('selected-vertical');
        this.verticalFilter.setTagContainerCaption('Selected vertical:');


        this.productFilter = new multipleSelector_template("productFilter", this.getTemplateViewModel(), this.caller);
        this.productFilter.setLabel("Product");
        this.productFilter.setFilterContainerClass('margin-neg');
        this.productFilter.setTagContainerId('selected-product');
        this.productFilter.setTagContainerCaption('Selected product:');
        
        this.partnerFilter = new multipleSelector_template("partnerFilter", this.getTemplateViewModel(), this.caller);
        this.partnerFilter.setLabel("Partner");
        this.partnerFilter.setFilterContainerClass('margin-neg');
        this.partnerFilter.setTagContainerId('selected-partner');
        this.partnerFilter.setTagContainerCaption('Selected partner:');

        this.campaignFilter = new multipleSelector_template("campaignFilter", this.getTemplateViewModel(), this.caller);
        this.campaignFilter.setLabel("Campaign name");
        this.campaignFilter.setFilterContainerClass('margin-neg');
        this.campaignFilter.setTagContainerId('selected-campaign');
        this.campaignFilter.setTagContainerCaption('Selected campaign name:');
        this.campaignLabelFilter = new multipleSelector_template("campaignLabelFilter", this.getTemplateViewModel(), this.caller);
        this.campaignLabelFilter.setLabel("Campaign label");
        this.campaignLabelFilter.setFilterContainerClass('margin-neg');
        this.campaignLabelFilter.setTagContainerId('selected-campaign-label');
        this.campaignLabelFilter.setTagContainerCaption('Selected campaign label:');
        this.adGroupFilter = new multipleSelector_template("adGroupFilter", this.getTemplateViewModel(), this.caller);
        this.adGroupFilter.setLabel("Ad group");
        this.adGroupFilter.setFilterContainerClass('margin-neg');
        this.adGroupFilter.setTagContainerId('selected-ad-group');
        this.adGroupFilter.setTagContainerCaption('Selected ad group:');
        this.formVariantFilter = new multipleSelector_template("formVariantFilter", this.getTemplateViewModel(), this.caller);
        this.formVariantFilter.setLabel("Form Variant");
        this.formVariantFilter.setFilterContainerClass('margin-neg');
        this.formVariantFilter.setTagContainerId('selected-form-variant');
        this.formVariantFilter.setTagContainerCaption('Selected form variant:');
        this.stateFilter = new multipleSelector_template("stateFilter", this.getTemplateViewModel(), this.caller);
        this.stateFilter.setLabel("State");
        this.stateFilter.setFilterContainerClass('margin-neg');
        this.stateFilter.setTagContainerId('selected-state');
        this.stateFilter.setTagContainerCaption('Selected state:');
        
        this.distributionChannelFilter = new multipleSelector_template("distributionChannelFilter", this.getTemplateViewModel(), this.caller);
        this.distributionChannelFilter.setLabel("Distribution Channel");
        this.distributionChannelFilter.setFilterContainerClass('margin-neg');
        this.distributionChannelFilter.setTagContainerId('selected-distribution-channel');
        this.distributionChannelFilter.setTagContainerCaption('Selected distribution channel:');

        this.leadBuyerFilter = new multipleSelector_template("leadBuyerFilter", this.getTemplateViewModel(), this.caller);
        this.leadBuyerFilter.setLabel("Lead Buyer");
        this.leadBuyerFilter.setFilterContainerClass('margin-neg');
        this.leadBuyerFilter.setTagContainerId('selected-lead-buyer');
        this.leadBuyerFilter.setTagContainerCaption('Selected lead buyer:');

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);
        this.exportDataCsv = new exportDataCsv();

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){

            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{

            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="sub-header w-justify">

               ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                    <div>
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Brands</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: brandOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: brandOptions">
                                        <input type="radio" data-bind="checked : $parent.brandOptionSelected, value: id,  attr: { 'id': 'brand_' + id, 'name' : 'brand_' + id }, event:{ change: $parent.onBrandOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'brand_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    ${this.verticalFilter.getHtmlBuild()}
                    ${this.productFilter.getHtmlBuild()}
                    ${this.partnerFilter.getHtmlBuild()}
                    <div>
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Traffic Source</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: trafficSourceOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: trafficSourceOptions">
                                        <input type="radio" data-bind="checked : $parent.trafficSourceOptionSelected, value: id,  attr: { 'id': 'traffic_source_' + id, 'name' : 'traffic_source_' + id }, event:{ change: $parent.onTrafficSourceOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'traffic_source_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    ${this.distributionChannelFilter.getHtmlBuild()}
                    <div>
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Form</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: formOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: formOptions">
                                        <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    ${this.datesFilter.getHtmlBuild()}
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Display Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: displayModeSelectedText"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: displayModes">
                                    <input type="radio" data-bind="checked : $parent.displayModeSelected, value: id,  attr: { 'id': 'display_' + id, 'name' : 'display_' + id }, event:{ change: $parent.onDisplayModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'display_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="dropdown select-single">
                            <label class="form-label" for="">Device</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: deviceOptionSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: deviceOptions">
                                        <input type="radio" data-bind="checked : $parent.deviceOptionSelected, value: id,  attr: { 'id': 'device_' + id, 'name' : 'device_' + id }, event:{ change: $parent.onDeviceOptionChange}">
                                        <label class="form-label" data-bind="attr: {for : 'device_' + id }, text: name"></label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="leadgen-advanced-filters" data-bind="css: { 'is-open': advancedFiltersOpen }">
                    
                        <button
                            type="button"
                            class="btn leadgen-advanced-filters-trigger"
                            data-bind="
                                css: { 'is-open': advancedFiltersOpen },
                                click: toggleAdvancedFilters,
                                attr: { 'aria-expanded': advancedFiltersOpen() }
                            "
                        >Advanced filters</button>
                        <div
                            class="leadgen-advanced-filters-panel"
                            data-bind="visible: advancedFiltersOpen"
                            aria-label="Advanced filters"
                        >
                            <div class="leadgen-advanced-filters-panel-header">
                                <strong class="leadgen-advanced-filters-panel-title">Advanced filters</strong>
                                <button
                                    type="button"
                                    class="btn icon i-x-after leadgen-advanced-filters-close"
                                    aria-label="Close advanced filters"
                                    data-bind="click: closeAdvancedFilters"
                                ></button>
                            </div>
                            <div class="leadgen-advanced-filters-grid">
                                <div class="leadgen-filter-category">
                                    <label class="group-label">Report view</label>
                                    <div class="leadgen-filter-category-filters">
                                        <div class="dropdown select-single">
                                            <label class="form-label" for="">Version</label>
                                            <button class="dropdown-toggle" type="button" data-bind="text: versionSelectedText"></button>

                                            <div class="dropdown-list">
                                                <div class="w-form">
                                                    <div class="form-group" data-bind="foreach: versions">
                                                        <input type="radio" data-bind="checked : $parent.versionSelected, value: id,  attr: { 'id': 'version_' + id, 'name' : 'version_' + id }, event:{ change: $parent.onVersionChange}">
                                                        <label class="form-label" data-bind="attr: {for : 'version_' + id }, text: name"></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="leadgen-filter-category leadgen-filter-category--campaign">
                                    <label class="group-label">Campaign &amp; form</label>
                                    <div class="leadgen-filter-category-filters">
                                        ${this.campaignFilter.getHtmlBuild()}
                                        ${this.campaignLabelFilter.getHtmlBuild()}
                                        ${this.adGroupFilter.getHtmlBuild()}
                                        ${this.formVariantFilter.getHtmlBuild()}
                                    </div>
                                </div>
                                <div class="leadgen-filter-category">
                                    <label class="group-label">Segments</label>
                                    <div class="leadgen-filter-category-filters">
                                        <div>
                                            <div class="dropdown select-single">
                                                <label class="form-label" for="">Military Affiliation</label>
                                                <button class="dropdown-toggle" type="button" data-bind="text: militaryAffiliationOptionSelectedText"></button>

                                                <div class="dropdown-list">
                                                    <div class="w-form">
                                                        <div class="form-group" data-bind="foreach: militaryAffiliationOptions">
                                                            <input type="radio" data-bind="checked: $parent.militaryAffiliationOptionSelected, value: id, attr: { 'id': 'military_affiliation_' + id, 'name': 'military_affiliation_' + id }, event: { change: $parent.onMilitaryAffiliationOptionChange }">
                                                            <label class="form-label" data-bind="attr: { for: 'military_affiliation_' + id }, text: name"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        ${this.stateFilter.getHtmlBuild()}
                                    </div>
                                </div>
                                <div class="leadgen-filter-category">
                                    <label class="group-label">Lead routing</label>
                                    <div class="leadgen-filter-category-filters">
                                        ${this.leadBuyerFilter.getHtmlBuild()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            ${this.validationsList.getHtmlBuild()}

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-vertical"></div>
                   <div id="selected-product"></div>
                   <div id="selected-partner"></div>
                   <div id="selected-campaign"></div>
                   <div id="selected-campaign-label"></div>
                   <div id="selected-ad-group"></div>
                   <div id="selected-form-variant"></div>
                   <div id="selected-state"></div>
                   <div id="selected-distribution-channel"></div>
                   <div id="selected-lead-buyer"></div>
                </div>
            </div>
            <div class="list-header w-justify">
                <div class="w-left">
                    <h3 class="section-title icon i-user">
                        <span class="leadgen-section-title-row">
                            <span data-bind="text: leadgenSectionTitle"></span>
                        </span>
                    </h3>
                </div>
                <div class="w-right">
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}">Export</button>
                </div>
            </div>
            <div class="w-list-results"id="list-results" style="position: relative">
                <table class="list-results list-sections">
                    <thead>
                        <tr class="list-header-section">
                            <!-- ko foreach: headers -->
                                <!-- ko if: !$data.hidden -->
                                <th data-bind="attr: { colspan: $parent.getColspanForHeader($data) }, css: $data.style">
                                    <span data-bind="text: $data.name"></span>
                                </th>
                                <!-- /ko -->
                            <!-- /ko -->
                        </tr>
                        <tr class="list-header-section" data-bind="css: { 'leadgen-tooltip-row-open': headerTooltipOpenColumn() }">
                            <!-- ko foreach: headers -->
                                <!-- ko if: !$data.hidden -->
                                <!-- ko foreach: subHeaders -->
                                    <!-- ko if: $parents[1].isSubHeaderVisible($data) -->
                                        <th data-bind="
                                            css: $parents[1].getSubHeaderClass($data),
                                            attr: {
                                                colspan: $parents[1].getColspanForSubHeader($data),
                                                rowspan: $parents[1].getRowspanForSubHeader($data)
                                            }
                                        ">
                                            <!-- ko if: $data.column === 'date' -->
                                                <span class="icon list-sort-none align-right"
                                                      data-bind="text: $data.name, event: { click: $parents[1].onClickReorder.bind($data, 'date') }, css: { 'list-sort-desc': $parents[1].orderByAndDirection()== 'date_DESC', 'list-sort-asc': $parents[1].orderByAndDirection()== 'date_ASC' }"></span>
                                            <!-- /ko -->
                                            <!-- ko if: $data.column !== 'date' -->
                                                <span class="align-right">
                                                    <span data-bind="text: $data.name"></span>
                                                    <!-- ko if: $parents[1].subHeaderHasSubColumns($data) -->
                                                    <span style="display: block; margin-top: 0.8rem; text-align: left;">
                                                        <button type="button" class="icon fix-width leadgen-subcolumn-toggle" data-bind="
                                                            css: $parents[1].getSubColumnToggleClass($data),
                                                            attr: { 'aria-label': $parents[1].getSubColumnToggleLabel($data) },
                                                            event: { click: function(subHeader, event) { return $parents[1].toggleSubColumns(subHeader.column, event); } }
                                                        "></button>
                                                    </span>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[1].subHeaderHasTooltip($data) -->
                                                    <div class="w-tooltips-adv auto-height pos-last leadgen-column-header-tooltip">
                                                        <div class="infoButton" style="position: relative">
                                                            <button type="button" class="open-button icon i-help" aria-label="Column description" data-bind="event: { click: function() { $parents[1].toggleHeaderTooltipColumn($data.column); } }"></button>
                                                            <div class="tooltips-adv" data-bind="visible: $parents[1].headerTooltipOpenColumn() === $data.column">
                                                                <h3 class="tooltips-adv-title" data-bind="text: $data.name"></h3>
                                                                <div class="tooltips-adv-content">
                                                                    <p data-bind="text: $data.tooltip"></p>
                                                                </div>
                                                                <button type="button" class="close-button icon i-x-after" aria-label="Close" data-bind="event: { click: function() { $parents[1].headerTooltipOpenColumn(null); } }"></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- /ko -->
                                                </span>
                                            <!-- /ko -->
                                        </th>
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- /ko -->
                            <!-- /ko -->
                        </tr>
                        <!-- ko if: hasExpandedSubColumns() -->
                        <tr class="list-header-section leadgen-subcolumn-header-row">
                            <!-- ko foreach: headers -->
                                <!-- ko if: !$data.hidden -->
                                <!-- ko foreach: subHeaders -->
                                    <!-- ko if: $parents[1].isSubHeaderVisible($data) && $parents[1].isSubHeaderExpanded($data) -->
                                        <!-- ko foreach: $parents[1].getSubColumnsForSubHeader($data) -->
                                            <th data-bind="css: $data.style">
                                                <span class="align-right" data-bind="text: $data.name"></span>
                                            </th>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- /ko -->
                            <!-- /ko -->
                        </tr>
                        <!-- /ko -->
                    </thead>
                    <tbody>
                        <!-- ko foreach: { data: leadgenData, as: 'row' } -->
                        <tr data-bind="
                            css: {
                                total: $index() === ($parent.leadgenData().length - 1),
                                'is-clicked': $parent.selectedRows().indexOf($index()) !== -1
                            },
                            click: function() { $parent.onClickRowClick($index(), row); }
                            ">                            <!-- ko foreach: $parent.headers -->
                                <!-- ko if: !$data.hidden -->
                                <!-- ko foreach: subHeaders -->
                                    <!-- ko if: $parents[2].isSubHeaderVisible($data) -->
                                    <!-- ko ifnot: $parents[2].isSubHeaderExpanded($data) -->
                                    <td class="align-right" style="white-space: nowrap" data-bind="css: $data.rowStyle">
                                        <span data-bind="text: $parents[2].formatDataExtra(
                                            row[$data.column], 
                                            $data.dataType, 
                                            $data.extraColumn ? row[$data.extraColumn] : null,
                                            $data.extraDataType ? $data.extraDataType : null,
                                            $data.not_applicable ? $data.not_applicable : null,
                                        )">
                                        </span>
                                    </td>
                                    <!-- /ko -->
                                    <!-- ko if: $parents[2].isSubHeaderExpanded($data) -->
                                        <!-- ko foreach: $parents[2].getSubColumnsForSubHeader($data) -->
                                            <td class="align-right" style="white-space: nowrap" data-bind="css: $data.rowStyle">
                                                <span data-bind="text: $parents[3].formatData(row[$data.column], $data.dataType, $data.not_applicable)"></span>
                                            </td>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- /ko -->
                            <!-- /ko -->
                        </tr>
                        <!-- /ko -->
                    </tbody>
                </table>
            </div>
             <!-- Leadgen charts (hidden for "new" version layout) -->
            <!-- ko if: showLeadgenCharts -->
            <table width="100%" style="table-layout: fixed;">
                <tr>
                    <td style="width: 50%;">
                    <div class="leadgen-chart-card" style="height: 300px; width: 100%;">
                        <div class="leadgen-chart-header">
                        <div class="leadgen-chart-title-text" id="leadgen-revenue-title" style="font-size: 16px;"></div>
                        <select class="leadgen-chart-section-select" id="leadgen-revenue-section-select"></select>
                        <select class="leadgen-chart-metric-select" id="leadgen-revenue-select"></select>
                        </div>
                        <div id="leadgen-revenue-chart" class="leadgen-chart" style="height: 100%;"></div>
                    </div>
                    </td>

                    <td style="width: 50%;">
                    <div class="leadgen-chart-card" style="height: 300px; width: 100%;">
                        <div class="leadgen-chart-header">
                        <div class="leadgen-chart-title-text" id="leadgen-spend-title" style="font-size: 16px;"></div>
                        <select class="leadgen-chart-section-select" id="leadgen-spend-section-select"></select>
                        <select class="leadgen-chart-metric-select" id="leadgen-spend-select"></select>
                        </div>
                        <div id="leadgen-spend-chart" class="leadgen-chart" style="height: 100%;"></div>
                    </div>
                    </td>
                </tr>
                </table>
            <!-- /ko -->
        `;
    }

    protected buildViewModel(): any {
        
        let self = this;

        let vm: any = {
            selectedRows: ko.observableArray([]),
            headers: ko.observableArray([]),
            leadgenData: ko.observableArray([]),
            csvExportData: ko.observableArray([]),
            brandOptionSelectedText : ko.observable("All"),
            brandOptionSelected : ko.observable("all"),
            brandOptions : ko.observableArray([]),
            selectedBrands: ko.observableArray([]),
            showSpendBreakdown: ko.observable(false),
            colapsSpendButtonClass: ko.observable("i-expand"),
            colapsSpendButtonText: ko.observable("expand"),
            expandedSubColumnParents: ko.observableArray([]),
            deviceOptionSelectedText : ko.observable("All"),
            deviceOptionSelected : ko.observable("all"),
            deviceOptions : ko.observableArray([]),
            formOptionSelectedText : ko.observable("All"),
            formOptionSelected : ko.observable("all"),
            formOptions : ko.observableArray([]),
            militaryAffiliationOptionSelectedText : ko.observable("All"),
            militaryAffiliationOptionSelected : ko.observable("all"),
            militaryAffiliationOptions : ko.observableArray([]),
            trafficSourceOptionSelectedText : ko.observable("All"),
            trafficSourceOptionSelected : ko.observable("all"),
            trafficSourceOptions : ko.observableArray([]),
            versionSelectedText : ko.observable("current"),
            versionSelected : ko.observable("current"),
            versions : ko.observableArray([]),
            displayModeSelectedText : ko.observable("Date"),
            displayModeSelected : ko.observable("date"),
            displayModes : ko.observableArray([]),
            orderBy: ko.observable("date"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("date_ASC"),
            onClickRowClick: function(index, data){ self.onClickRowClick(index); return true; },
            formatData: function(value, type, not_applicable){return self.formatData(value, type, not_applicable);},
            formatDataExtra: function(value, type, value2, type2, not_applicable){return self.formatDataExtra(value, type, value2, type2, not_applicable);},
            exportData: function(){ self.getCsvData(self); },
            onColapseSpendBreakdown: function(){ self.onColapseSpendBreakdown(); },
            onBrandOptionChange : function(data){ self.onBrandOptionChange(data); },
            onDeviceOptionChange : function(data){ self.onDeviceOptionChange(data); },
            onFormOptionChange : function(data){ self.onFormOptionChange(data); },
            onMilitaryAffiliationOptionChange : function(data){ self.onMilitaryAffiliationOptionChange(data); },
            onTrafficSourceOptionChange : function(data){ self.onTrafficSourceOptionChange(data); },
            onVersionChange : function(data){ self.onVersionChange(data); },
            onDisplayModeChange : function(data){ self.onDisplayModeChange(data); },
            onClickReorder: function(value, data, event){ self.onClickReorder(value, data, event); },
            getColspanForHeader: function(header){ 
                if (!header.subHeaders) return 1;
                let count = 0;
                for (let subHeader of header.subHeaders) {
                    if (self.isSubHeaderVisible(subHeader)) {
                        if (self.isSubHeaderExpanded(subHeader)) {
                            count += self.getSubColumnsForSubHeader(subHeader).length;
                        } else {
                            count++;
                        }
                    }
                }
                return count;
            },
            isSubHeaderVisible: function(subHeader){ return self.isSubHeaderVisible(subHeader); },
            subHeaderHasSubColumns: function(subHeader){ return self.subHeaderHasSubColumns(subHeader); },
            isSubHeaderExpanded: function(subHeader){ return self.isSubHeaderExpanded(subHeader); },
            toggleSubColumns: function(column, event){ return self.toggleSubColumns(column, event); },
            getSubColumnsForSubHeader: function(subHeader){ return self.getSubColumnsForSubHeader(subHeader); },
            getSubHeaderClass: function(subHeader){ return self.getSubHeaderClass(subHeader); },
            getColspanForSubHeader: function(subHeader){ return self.getColspanForSubHeader(subHeader); },
            getRowspanForSubHeader: function(subHeader){ return self.getRowspanForSubHeader(subHeader); },
            getSubColumnToggleClass: function(subHeader){ return self.getSubColumnToggleClass(subHeader); },
            getSubColumnToggleLabel: function(subHeader){ return self.getSubColumnToggleLabel(subHeader); },
            hasExpandedSubColumns: function(){ return self.hasExpandedSubColumns(); },
            headerTooltipOpenColumn: ko.observable(null as string | null),
            /** True when API sent a non-empty tooltip string (tooltip is not_applicable on subHeaders). */
            subHeaderHasTooltip: function (subHeader: { tooltip?: string | null }) {
                const t = subHeader?.tooltip;
                return t != null && String(t).trim() !== "";
            },
            toggleHeaderTooltipColumn: function (column: string) {
                if (vm.headerTooltipOpenColumn() === column) {
                    vm.headerTooltipOpenColumn(null);
                } else {
                    vm.headerTooltipOpenColumn(column);
                }
            },
            leadgenSectionTooltipOpen: ko.observable(false),
            leadgenSectionTooltipText: "This is a work in progress",
            toggleLeadgenSectionTooltip: function () {
                vm.leadgenSectionTooltipOpen(!vm.leadgenSectionTooltipOpen());
            },
            closeLeadgenSectionTooltip: function () {
                vm.leadgenSectionTooltipOpen(false);
            },
            advancedFiltersOpen: ko.observable(false),
            toggleAdvancedFilters: function (_data, event) {
                if (event && event.stopPropagation) {
                    event.stopPropagation();
                }
                vm.advancedFiltersOpen(!vm.advancedFiltersOpen());
                return false;
            },
            closeAdvancedFilters: function () {
                vm.advancedFiltersOpen(false);
            },
            closeAdvancedFiltersOnOutside: function (event) {
                let target = event && event.target;
                if (!target || typeof target.closest !== "function") {
                    return;
                }
                if (!target.closest(".leadgen-advanced-filters")) {
                    vm.advancedFiltersOpen(false);
                }
            },
        };
        vm.advancedFiltersOpen.subscribe(function (isOpen) {
            if (isOpen) {
                setTimeout(function () {
                    document.addEventListener("click", vm.closeAdvancedFiltersOnOutside);
                }, 0);
            } else {
                document.removeEventListener("click", vm.closeAdvancedFiltersOnOutside);
            }
        });
        vm.showLeadgenCharts = ko.pureComputed(() => vm.versionSelected() !== "new");
        vm.leadgenSectionTitle = ko.pureComputed(() =>
            vm.versionSelected() === "new" ? "Leads Report (Beta)" : "Leads Report"
        );
        return vm;
    }

    public setCsvExportData(csvExportData){

        this.getTemplateViewModel().csvExportData(csvExportData);
    }

    private onBrandOptionChange(selectedBrandOption){

        this.getTemplateViewModel().brandOptionSelectedText(selectedBrandOption.name);
        this.updateCampaignOptionsFromBrands();

        this.caller.getListData();
    }

    private onDeviceOptionChange(selectedDeviceOption){

        this.getTemplateViewModel().deviceOptionSelectedText(selectedDeviceOption.name);

        this.caller.getListData();
    }

    private onFormOptionChange(selectedFormOption){

        this.getTemplateViewModel().formOptionSelectedText(selectedFormOption.name);

        this.caller.getListData();
    }

    private onMilitaryAffiliationOptionChange(selectedOption){

        this.getTemplateViewModel().militaryAffiliationOptionSelectedText(selectedOption.name);

        this.caller.getListData();
    }

    private onTrafficSourceOptionChange(selectedTrafficSourceOption){

        this.getTemplateViewModel().trafficSourceOptionSelectedText(selectedTrafficSourceOption.name);

        this.caller.getListData();
    }

    private onVersionChange(selectedVersion){

        this.getTemplateViewModel().versionSelectedText(selectedVersion.name);
        this.getTemplateViewModel().leadgenSectionTooltipOpen(false);

        if (this.getTemplateViewModel().versionSelected() === "new") {
            this.disposeAllLeadgenCharts();
        }

        this.caller.getListData();
    }

    private onDisplayModeChange(selectedDisplayMode){

        this.getTemplateViewModel().displayModeSelectedText(selectedDisplayMode.name);

        this.caller.getListData();
    }
    
    private exportCsvData(){

        let exportDataView = [];
        for(let row of this.getTemplateViewModel().csvExportData().leadgenData){
            let exportDataViewRow = [];
            for (let header of this.getTemplateViewModel().csvExportData().headers) {
                if (header.hidden) {
                    continue;
                }
                for (let subHeader of header.subHeaders){
                    if (!this.isSubHeaderVisible(subHeader)) {
                        continue;
                    }

                    if (!this.isSubHeaderExpanded(subHeader)) {
                        exportDataViewRow[subHeader.column] = this.formatData(row[subHeader.column], subHeader.dataType, subHeader.not_applicable);
                        continue;
                    }

                    for (let subColumn of this.getSubColumnsForSubHeader(subHeader)) {
                        exportDataViewRow[subColumn.column] = this.formatData(row[subColumn.column], subColumn.dataType, subColumn.not_applicable);
                    }
                }
            }
            exportDataView.push(exportDataViewRow);
        }
        let fileName = "leadsReport_data" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportDataCsv.exportToCsv(fileName, exportDataView);

    }

    private getCsvData(obj){

        this.caller.getListDataForCSV();
    }
    
    public getViewModelForRequest() {
        return {
            dateStart: this.getTemplateViewModel().datesFilter.startDate(),
            dateEnd: this.getTemplateViewModel().datesFilter.endDate(),
            selectedBrands: this.getSelectedBrandsForRequest(),
            showSpendBreakdown: this.getTemplateViewModel().showSpendBreakdown(),
            displayMode: this.getTemplateViewModel().displayModeSelected(),
            device: this.getTemplateViewModel().deviceOptionSelected(),
            vertical: this.getTemplateViewModel().verticalFilter.selectedItems(),
            product: this.getTemplateViewModel().productFilter.selectedItems(),
            productOptions: this.getTemplateViewModel().productFilter.items(),
            partner: this.getTemplateViewModel().partnerFilter.selectedItems(),
            campaign: this.getTemplateViewModel().campaignFilter.selectedItems(),
            campaignLabel: this.getTemplateViewModel().campaignLabelFilter.selectedItems(),
            adGroup: this.getTemplateViewModel().adGroupFilter.selectedItems(),
            formVariant: this.getTemplateViewModel().formVariantFilter.selectedItems(),
            militaryAffiliation: this.getTemplateViewModel().militaryAffiliationOptionSelected(),
            state: this.getTemplateViewModel().stateFilter.selectedItems(),
            form: this.getSelectedFormForRequest(),
            distributionChannel: this.getTemplateViewModel().distributionChannelFilter.selectedItems(),
            trafficSource: this.getSelectedTrafficSourceForRequest(),
            leadBuyer: this.getTemplateViewModel().leadBuyerFilter.selectedItems(),
            version: this.getTemplateViewModel().versionSelected(),
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
        };

    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }

    public setDeviceOptionsFilterItems(items){
        this.getTemplateViewModel().deviceOptions(items);
    }

    public setDisplayModeFilterItems(items){
        this.getTemplateViewModel().displayModes(items);
    }

    private getSelectedBrandsForRequest(): Array<any>{

        let selectedBrand = this.getTemplateViewModel().brandOptionSelected();

        if (!selectedBrand || selectedBrand === "all"){

            return [];
        }

        return [selectedBrand];
    }

    private getBrandSelectionFromRequest(selectedBrands): any{

        if (!Array.isArray(selectedBrands)){

            return selectedBrands || "all";
        }

        if (selectedBrands.length !== 1){

            return "all";
        }

        return selectedBrands[0] || "all";
    }

    private getSelectedFormForRequest(): Array<string>{

        let selectedForm = this.getTemplateViewModel().formOptionSelected();

        if (!selectedForm || selectedForm === "all"){

            return [];
        }

        return [selectedForm];
    }

    private getFormSelectionFromRequest(selectedForm): string{

        if (!Array.isArray(selectedForm)){

            return selectedForm || "all";
        }

        if (selectedForm.length !== 1){

            return "all";
        }

        return selectedForm[0] || "all";
    }

    private getFilterTextFromId(filtersOptions: Array<{id, name}>, id): string{

        let option = filtersOptions.filter((o) => (o.id == id)).shift();

        if (!option){

            return "All";
        }

        return option.name;
    }

    private getSelectedTrafficSourceForRequest(): Array<string>{

        let selectedTrafficSource = this.getTemplateViewModel().trafficSourceOptionSelected();

        if (!selectedTrafficSource || selectedTrafficSource === "all"){

            return [];
        }

        return [selectedTrafficSource];
    }

    private getTrafficSourceSelectionFromRequest(selectedTrafficSource): string{

        if (!Array.isArray(selectedTrafficSource)){

            return selectedTrafficSource || "all";
        }

        if (selectedTrafficSource.length !== 1){

            return "all";
        }

        return selectedTrafficSource[0] || "all";
    }


    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }

    public setVerticalFilterItems(items){

        this.allVerticalOptions = items || [];
        this.verticalFilter.setItems(items);
    }

    public setProductOptionsByVertical(itemsByVertical){

        this.productOptionsByVertical = itemsByVertical || {};
        this.updateProductOptionsFromVerticals();
    }

    public getSelectedVerticalIds(){

        return this.getTemplateViewModel().verticalFilter.selectedItems();
    }

    public getSelectedProductIds(){

        return this.getTemplateViewModel().productFilter.selectedItems();
    }

    public updateProductFilterOptions(items, selectedIds){

        // Guard against undefined selections during filter updates.
        let safeSelectedIds = selectedIds || [];
        let selectedItems = safeSelectedIds.map((id) => ({ id: id }));

        this.productFilter.setMultiSectionItems(items);
        this.productFilter.setSelectedItems(selectedItems);
        this.productFilter.setTags(safeSelectedIds, this.productFilter.getItems());
    }

    public updateProductOptionsFromVerticals(): void{

        let selectedVerticals = this.getSelectedVerticalIds();
        let nextProductOptions = this.getProductGroupsForVerticals(selectedVerticals);
        let selectedProductIds = this.getSelectedProductIds();
        let allowedIds = new Set();

        for (let group of nextProductOptions){

            for (let product of group.items || []){

                allowedIds.add(product.id);
            }
        }

        let nextSelectedProductIds = selectedProductIds.filter((id) => allowedIds.has(id));

        this.updateProductFilterOptions(nextProductOptions, nextSelectedProductIds);
        this.expandProductGroupsForSelectedVerticals(selectedVerticals);
    }

    private expandProductGroupsForSelectedVerticals(selectedVerticalIds: Array<any>): void{

        let selectedIds = new Set(selectedVerticalIds || []);
        let groupNames = (selectedIds.size === 0)
            ? []
            : (this.allVerticalOptions || [])
                .filter((vertical) => selectedIds.has(vertical.id))
                .map((vertical) => vertical.name);

        this.productFilter.getTemplateViewModel().openedGroupsDrawers(groupNames);
    }

    private getProductGroupsForVerticals(selectedVerticals: Array<any>): Array<any>{

        let verticalOptions = this.getSortedOptionsByName(this.allVerticalOptions);
        if (selectedVerticals && selectedVerticals.length > 0){

            let selectedVerticalIds = new Set(selectedVerticals);
            verticalOptions = this.getSortedOptionsByName(this.allVerticalOptions.filter((vertical) => selectedVerticalIds.has(vertical.id)));
        }

        let productGroups = [];
        for (let vertical of verticalOptions){

            let products = this.getSortedOptionsByName(this.productOptionsByVertical[vertical.id] || []);

            if (products.length === 0){

                continue;
            }

            productGroups.push({name: vertical.name, items: products});
        }

        return productGroups.sort((a, b) => a.name.localeCompare(b.name));
    }

    private getSortedOptionsByName(items: Array<any>): Array<any>{

        return (items || []).slice().sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    }


    public setPartnerFilterItems(items){

        this.partnerFilter.setItems(items);
    }

    public setCampaignFilterItems(items){

        this.allCampaignGroups = items || [];
        this.updateCampaignOptions();
    }

    public setCampaignLabelFilterItems(items){

        this.updateSimpleMultiSelectorItems(this.campaignLabelFilter, items);
    }

    public setAdGroupFilterItems(items){

        this.updateSimpleMultiSelectorItems(this.adGroupFilter, items);
    }

    public setFormVariantFilterItems(items){

        this.updateSimpleMultiSelectorItems(this.formVariantFilter, items);
    }

    public setStateFilterItems(items){

        this.updateSimpleMultiSelectorItems(this.stateFilter, items);
    }

    private updateSimpleMultiSelectorItems(filter: multipleSelector_template, items): void{

        const nextItems = items ?? [];
        const nextIds = nextItems.map(it => (typeof it === "object" ? it.id : it));
        const currentSelectedIds = (filter.getSelectedItems() ?? [])
            .map(s => (typeof s === "object" ? s.id : s));

        const keptSelectedIds = currentSelectedIds.filter(id => nextIds.includes(id));
        const keptSelectedItems = keptSelectedIds.map(id => ({ id }));

        filter.setItems(nextItems);
        filter.setSelectedItems(keptSelectedItems);
        filter.setTags(keptSelectedIds, filter.getItems());
    }

    public updateCampaignOptionsFromBrands(): void{
        this.updateCampaignOptions();
    }

    public updateCampaignOptions(): void{

        let nextCampaignGroups = this.getCampaignGroups();
        let allowedCampaignIds = new Set<string | number>();

        for (let group of nextCampaignGroups){

            for (let campaign of group.items || []){

                allowedCampaignIds.add(campaign.id);
            }
        }

        let currentSelectedCampaignIds = this.campaignFilter.getSelectedItems() || [];
        let nextSelectedCampaignIds = currentSelectedCampaignIds.filter((id) => allowedCampaignIds.has(id));
        let nextSelectedCampaignItems = nextSelectedCampaignIds.map((id) => ({ id: id }));

        this.campaignFilter.setMultiSectionItems(nextCampaignGroups);
        this.campaignFilter.setSelectedItems(nextSelectedCampaignItems);
        this.campaignFilter.setTags(nextSelectedCampaignIds, this.campaignFilter.getItems());
    }

    private getCampaignGroups(): Array<any>{

        let selectedVerticals = this.getSelectedVerticalIds();
        let selectedProducts = this.getSelectedProductIds();
        let selectedVerticalIds = new Set(selectedVerticals || []);
        let selectedProductIds = new Set(selectedProducts || []);

        return (this.allCampaignGroups || []).filter((group) => {

            if (group.isUngrouped){

                return true;
            }

            let verticalAllowed = selectedVerticalIds.size === 0 || selectedVerticalIds.has(group.verticalId);
            let productAllowed = selectedProductIds.size === 0 || selectedProductIds.has(group.productId);

            return verticalAllowed && productAllowed;
        });
    }

    public setDistributionChannelFilterItems(items){

        const nextIds = (items ?? []).map(it => (typeof it === "object" ? it.id : it));
        const currentSelectedIds = (this.distributionChannelFilter.getSelectedItems() ?? [])
            .map(s => (typeof s === "object" ? s.id : s));

        const keptSelectedIds = currentSelectedIds.filter(id => nextIds.includes(id));
        const keptSelectedItems = keptSelectedIds.map(id => ({ id }));

        this.distributionChannelFilter.setItems(items ?? []);
        this.distributionChannelFilter.setSelectedItems(keptSelectedItems);

        this.distributionChannelFilter.setTags(keptSelectedIds, this.distributionChannelFilter.getItems());
    }

    public setTrafficSourceFilterItems(items){

        let trafficSourceOptions = items || [];
        if (!trafficSourceOptions.some((item) => item.id === "all")){

            trafficSourceOptions = [{id: "all", name: "All"}].concat(trafficSourceOptions);
        }

        this.getTemplateViewModel().trafficSourceOptions(trafficSourceOptions);
    }

    public setLeadBuyerFilterItems(items) {
        const nextIds = (items ?? []).map(it => (typeof it === "object" ? it.id : it));
        const currentSelectedIds = (this.leadBuyerFilter.getSelectedItems() ?? [])
            .map(s => (typeof s === "object" ? s.id : s));

        const keptSelectedIds = currentSelectedIds.filter(id => nextIds.includes(id));
        const keptSelectedItems = keptSelectedIds.map(id => ({ id }));

        this.leadBuyerFilter.setItems(items ?? []);
        this.leadBuyerFilter.setSelectedItems(keptSelectedItems);

        this.leadBuyerFilter.setTags(keptSelectedIds, this.leadBuyerFilter.getItems());
     }

    public setFormFilterItems(items){

        let formOptions = items || [];
        if (!formOptions.some((item) => item.id === "all")){

            formOptions = [{id: "all", name: "All"}].concat(formOptions);
        }

        this.getTemplateViewModel().formOptions(formOptions);
    }

    public setMilitaryAffiliationFilterItems(items){

        let options = items || [];
        this.getTemplateViewModel().militaryAffiliationOptions(options);

        let selected = this.getTemplateViewModel().militaryAffiliationOptionSelected();
        if (!options.some((option) => option.id == selected)){

            this.getTemplateViewModel().militaryAffiliationOptionSelected("all");
            this.getTemplateViewModel().militaryAffiliationOptionSelectedText("All");
        }
    }

    public setVersionFilterItems(items){

        this.getTemplateViewModel().versions(items || []);
    }

    public setBrandFilterItems(departments){

        let brandOptions = [{id: "all", name: "All"}];
        for ( let department of departments){

            for (let brand of department.brands || []){

                brandOptions.push({id: brand.id, name: brand.name});
            }
        }

        brandOptions = [brandOptions[0]].concat(brandOptions.slice(1).sort((a, b) => a.name.localeCompare(b.name)));

        this.getTemplateViewModel().brandOptions(brandOptions);
        this.resetSelectedBrandIfUnavailable(brandOptions);
    }

    private resetSelectedBrandIfUnavailable(brandOptions: Array<any>): void{

        let selectedBrand = this.getTemplateViewModel().brandOptionSelected();

        if (!selectedBrand || selectedBrand === "all"){

            return;
        }

        if (!brandOptions.some((brandOption) => brandOption.id == selectedBrand)){

            this.getTemplateViewModel().brandOptionSelected("all");
            this.getTemplateViewModel().brandOptionSelectedText("All");
        }
    }

    public setSelectedBrands(selectedBrands) {

        this.getTemplateViewModel().selectedBrands(selectedBrands);
    }

    public setHeaders(headers) {

        this.getTemplateViewModel().headerTooltipOpenColumn(null);
        this.getTemplateViewModel().headers(headers);
    }

    public setLeadgenData(leadgenData) {
        
        this.getTemplateViewModel().leadgenData(leadgenData);
    }

    private isSubHeaderVisible(subHeader: any): boolean {

        return !subHeader?.isSpendBreakdown || this.getTemplateViewModel().showSpendBreakdown();
    }

    private subHeaderHasSubColumns(subHeader: any): boolean {

        return Array.isArray(subHeader?.subColumns) && subHeader.subColumns.length > 0;
    }

    private isSubHeaderExpanded(subHeader: any): boolean {

        if (!this.subHeaderHasSubColumns(subHeader)) {
            return false;
        }

        return this.getExpandedSubColumnParents().includes(subHeader.column);
    }

    private getSubHeaderClass(subHeader: any): string {

        const classes = [subHeader?.style || ""];

        if (this.getTemplateViewModel().headerTooltipOpenColumn() === subHeader?.column) {
            classes.push("leadgen-tooltip-open");
        }

        return classes.join(" ").trim();
    }

    private toggleSubColumns(column: string, event?: Event): boolean {

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        let expandedSubColumnParents = this.getExpandedSubColumnParents();
        const index = expandedSubColumnParents.indexOf(column);

        if (index === -1) {
            expandedSubColumnParents.push(column);
        } else {
            expandedSubColumnParents.splice(index, 1);
        }

        this.getTemplateViewModel().expandedSubColumnParents(expandedSubColumnParents);

        return false;
    }

    private hasExpandedSubColumns(): boolean {

        const headers = this.getTemplateViewModel().headers() || [];

        for (let header of headers) {
            if (header.hidden) {
                continue;
            }

            for (let subHeader of header.subHeaders || []) {
                if (this.isSubHeaderVisible(subHeader) && this.isSubHeaderExpanded(subHeader)) {
                    return true;
                }
            }
        }

        return false;
    }

    private getColspanForSubHeader(subHeader: any): number {

        if (!this.isSubHeaderExpanded(subHeader)) {
            return 1;
        }

        return this.getSubColumnsForSubHeader(subHeader).length;
    }

    private getRowspanForSubHeader(subHeader: any): number {

        if (!this.hasExpandedSubColumns() || this.isSubHeaderExpanded(subHeader)) {
            return 1;
        }

        return 2;
    }

    private getExpandedSubColumnParents(): Array<string> {

        return (this.getTemplateViewModel().expandedSubColumnParents() || []).slice();
    }

    private getSubColumnsForSubHeader(subHeader: any): Array<any> {

        if (!this.subHeaderHasSubColumns(subHeader)) {
            return [];
        }

        return subHeader.subColumns.map((subColumn: any, index: number) => {
            const column = typeof subColumn === "string" ? subColumn : subColumn.column;

            return {
                column: column,
                name: subColumn.name || this.getSubColumnName(subHeader, column, index),
                style: this.getSubColumnClass(subColumn.style || subHeader.style),
                rowStyle: this.getSubColumnClass(subColumn.rowStyle || subHeader.rowStyle),
                dataType: subColumn.dataType || subHeader.dataType,
                not_applicable: subColumn.not_applicable || subHeader.not_applicable,
            };
        });
    }

    private getSubColumnName(subHeader: any, column: string, index: number): string {

        const prefix = `${subHeader.column}_`;
        if (column.indexOf(prefix) === 0) {
            return column.substring(prefix.length).replace(/_/g, " ");
        }

        return String(index + 1);
    }

    private getSubColumnClass(baseClass: string): string {

        const classes = String(baseClass || "")
            .split(/\s+/)
            .filter((className) => className && className !== "border-left");

        if (!classes.includes("expanded-cells")) {
            classes.push("expanded-cells");
        }

        return classes.join(" ");
    }

    private getSubColumnToggleClass(subHeader: any): string {

        return this.isSubHeaderExpanded(subHeader) ? "i-simplify" : "i-expand";
    }

    private getSubColumnToggleLabel(subHeader: any): string {

        const action = this.isSubHeaderExpanded(subHeader) ? "Collapse" : "Expand";

        return `${action} ${subHeader?.name || subHeader?.column || "subcolumns"}`;
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['device'] !== 'undefined'){

            this.getTemplateViewModel().deviceOptionSelected(params['device']);
            this.getTemplateViewModel().deviceOptionSelectedText(this.presetFilter.getFilterTextFromId(this.getTemplateViewModel().deviceOptions(), params['device']));
        }

        if(typeof params['version'] !== 'undefined'){

            this.getTemplateViewModel().versionSelected(params['version']);
            this.getTemplateViewModel().versionSelectedText(this.presetFilter.getFilterTextFromId(this.getTemplateViewModel().versions(), params['version']));
        }

         if(typeof params['displayMode'] !== 'undefined'){

            this.getTemplateViewModel().displayModeSelected(params['displayMode']);
            this.getTemplateViewModel().displayModeSelectedText(this.presetFilter.getFilterTextFromId(this.getTemplateViewModel().displayModes(), params['displayMode']));
        }

        if(typeof params['selectedBrands'] !== 'undefined'){

            let selectedBrand = this.getBrandSelectionFromRequest(params['selectedBrands']);
            this.getTemplateViewModel().brandOptionSelected(selectedBrand);
            this.getTemplateViewModel().brandOptionSelectedText(this.getFilterTextFromId(this.getTemplateViewModel().brandOptions(), selectedBrand));
        }

        this.presetFilter.setMultiSelectorPresetFilters(this.verticalFilter, params['vertical']);
        this.presetFilter.setMultiSelectorPresetFilters(this.productFilter, params['product']);
        this.presetFilter.setMultiSelectorPresetFilters(this.partnerFilter, params['partner']);
        this.presetFilter.setMultiSelectorPresetFilters(this.campaignFilter, params['campaign']);
        this.presetFilter.setMultiSelectorPresetFilters(this.campaignLabelFilter, params['campaignLabel']);
        this.presetFilter.setMultiSelectorPresetFilters(this.adGroupFilter, params['adGroup']);
        this.presetFilter.setMultiSelectorPresetFilters(this.formVariantFilter, params['formVariant']);
        this.presetFilter.setMultiSelectorPresetFilters(this.stateFilter, params['state']);
        this.presetFilter.setMultiSelectorPresetFilters(this.distributionChannelFilter, params['distributionChannel']);
        this.presetFilter.setMultiSelectorPresetFilters(this.leadBuyerFilter, params['leadBuyer']);

        if(typeof params['trafficSource'] !== 'undefined'){

            let selectedTrafficSource = this.getTrafficSourceSelectionFromRequest(params['trafficSource']);
            this.getTemplateViewModel().trafficSourceOptionSelected(selectedTrafficSource);
            this.getTemplateViewModel().trafficSourceOptionSelectedText(this.getFilterTextFromId(this.getTemplateViewModel().trafficSourceOptions(), selectedTrafficSource));
        }

        if(typeof params['form'] !== 'undefined'){

            let selectedForm = this.getFormSelectionFromRequest(params['form']);
            this.getTemplateViewModel().formOptionSelected(selectedForm);
            this.getTemplateViewModel().formOptionSelectedText(this.getFilterTextFromId(this.getTemplateViewModel().formOptions(), selectedForm));
        }

        if(typeof params['militaryAffiliation'] !== 'undefined'){

            let selectedMilitaryAffiliation = String(params['militaryAffiliation']);
            this.getTemplateViewModel().militaryAffiliationOptionSelected(selectedMilitaryAffiliation);
            this.getTemplateViewModel().militaryAffiliationOptionSelectedText(
                this.getFilterTextFromId(
                    this.getTemplateViewModel().militaryAffiliationOptions(),
                    selectedMilitaryAffiliation
                )
            );
        }

        if(typeof params['orderBy'] !== 'undefined'){

            this.getTemplateViewModel().orderBy(params['orderBy']);
        }

        if(typeof params['orderByDirection'] !== 'undefined'){

            this.getTemplateViewModel().orderByDirection(params['orderByDirection']);
        }

        if(typeof params['orderByAndDirection'] !== 'undefined'){

            this.getTemplateViewModel().orderByAndDirection(params['orderByAndDirection']);
        }


        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['dateStart'], params['dateEnd'], params['startDateRange'], params['endDateRange']);
    }

    private formatDataExtra(value, type, value2, type2, not_applicable) {

        if (value2 == null ||type2 == null ){
            return this.formatData(value, type, not_applicable);
        }
        return this.formatData(value, type, not_applicable) + ' (' + this.formatData(value2, type2, not_applicable) + ')';
    }

    private formatData(value, type, not_applicable) {
        if (not_applicable){
            return 'N/A';
        }
        if (type === "date" && value != "TOTAL") {
            return new Date(value).toLocaleDateString('en-CA', { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'UTC' });
        }
        if (type === "month" && value != "TOTAL") {
            return new Date(value).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', timeZone: 'UTC' });
        }

        if (type === "number") {
            return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})
        }

        if (type === "decimal") {
            return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (type === "percent") {
            return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
        }

        if (type === "percent1") {
            return Number(value).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%';
        }

        if (type === "dollar") {
            return '$' + Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        return value;
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }

    public onClickReorder(value, data, event){

        if (value !== 'date'){
            return;
        }

        if(typeof data.orderBy === 'undefined'){

            data = this.getTemplateViewModel();
        }
        data.orderBy(value);

        if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){

            if( data.orderByDirection() == "DESC" ){

                data.orderByDirection("ASC");
            }
            else{

                data.orderByDirection("DESC");
            }
        }
        else{

            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    private onColapseSpendBreakdown(){

        if(this.getTemplateViewModel().colapsSpendButtonText() == 'expand'){

            this.getTemplateViewModel().colapsSpendButtonClass('i-collapse');
            this.getTemplateViewModel().colapsSpendButtonText('collapse');
            this.getTemplateViewModel().showSpendBreakdown(true);

        }else{

            this.getTemplateViewModel().colapsSpendButtonClass('i-expand');
            this.getTemplateViewModel().colapsSpendButtonText('expand');
            this.getTemplateViewModel().showSpendBreakdown(false);
        }
    }

    private buildChartData(metricColumn: string): Array<any> {
        const vm = this.getTemplateViewModel();
        const rows = vm?.leadgenData?.() || [];

        return rows
            .filter(r => r && r.date && r.date !== "TOTAL")
            .map(r => {
                const [y, m, d] = r.date.split("-").map(Number);
                const value = r[metricColumn];
                return {
                    date: new Date(y, m - 1, d ?? 1),
                    value: value === null || value === undefined ? 0 : value,
                };
            })
            .sort((a, b) => a.date.getTime() - b.date.getTime());
    }

    private getHeaderNameFromColumn(columnName: string): string {

        const vm = this.getTemplateViewModel();
        const headers = vm?.headers?.() || [];

        for (const header of headers) {
            if (!header?.subHeaders) continue;

            for (const subHeader of header.subHeaders) {
                if (subHeader.column === columnName) {
                    return subHeader.name;
                }

                for (const subColumn of this.getSubColumnsForSubHeader(subHeader)) {
                    if (subColumn.column === columnName) {
                        return `${subHeader.name} ${subColumn.name}`;
                    }
                }
            }
        }

        return columnName;
    }

    public renderLeadgenChart(chartId: string, defaultMetric: string): void {

        if (this.getTemplateViewModel().versionSelected() === "new") {
            return;
        }

        const container = document.getElementById(chartId);
        if (!container) return;

        const sectionSelectId = chartId.replace("-chart", "-section-select");
        const metricSelectId = chartId.replace("-chart", "-select");
        const titleId = chartId.replace("-chart", "-title");

        this.populateSectionDropdown(sectionSelectId);

        const sectionSelect = document.getElementById(sectionSelectId) as HTMLSelectElement;
        const metricSelect = document.getElementById(metricSelectId) as HTMLSelectElement;
        const titleEl = document.getElementById(titleId);

        if (!sectionSelect || !metricSelect) return;

        const defaultSection = this.getSectionNameFromColumn(defaultMetric) || sectionSelect.value;
        if (defaultSection) {
            sectionSelect.value = defaultSection;
        }

        this.populateMetricDropdown(sectionSelect.value, metricSelectId);

        if (this.sectionHasMetric(sectionSelect.value, defaultMetric)) {
            metricSelect.value = defaultMetric;
        }

        const updateChart = (sectionName: string, metric: string) => {

            if (titleEl) {
                titleEl.innerText = `${sectionName}: ${this.getHeaderNameFromColumn(metric)}`;
            }

            this.renderMetricChart(chartId, metric, sectionName);
        };

        // First render
        updateChart(sectionSelect.value, metricSelect.value || defaultMetric);

        // Change event
        sectionSelect.onchange = () => {
            this.populateMetricDropdown(sectionSelect.value, metricSelectId);
            updateChart(sectionSelect.value, metricSelect.value);
        };

        metricSelect.onchange = () => {
            updateChart(sectionSelect.value, metricSelect.value);
        };
    }

    private renderMetricChart(chartId: string, metric: string, sectionName: string): void {
        const container = document.getElementById(chartId);
        if (!container) return;

        const data = this.buildChartData(metric);
        if (!data || data.length === 0) {
            container.innerHTML = "";
            this.disposeChart(chartId);
            return;
        }

        this.disposeChart(chartId);

        const chart = am4core.create(chartId, am4charts.XYChart);
        (chart as any).logo.disabled = true;
        this.leadgenCharts[chartId] = chart;

        chart.data = data;

        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        if (this.getTemplateViewModel().displayModeSelected() == "month"){
            dateAxis.baseInterval = { timeUnit: "month", count: 1 };
            dateAxis.tooltipDateFormat = "yyyy-MM";
        }
        else{
            dateAxis.baseInterval = { timeUnit: "day", count: 1 };
            dateAxis.tooltipDateFormat = "yyyy-MM-dd";
        }
        dateAxis.renderer.minGridDistance = 10;
        dateAxis.renderer.labels.template.rotation = -45;   // or 45
        dateAxis.renderer.labels.template.horizontalCenter = "right";
        dateAxis.renderer.labels.template.verticalCenter = "middle";

        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        const metricType = this.getDataTypeFromColumn(metric) || "number";

        valueAxis.renderer.labels.template.adapter.add("text", (text, target) => {
            const v = (target as any)?.dataItem?.value;
            if (v === undefined || v === null || !isFinite(v)) return text;
            return this.formatData(v, metricType, false);
        });

        const sectionColor = this.getSectionColor(sectionName);
        const series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";
        series.strokeWidth = 2;
        series.tooltipText = "{valueY}";
        series.adapter.add("tooltipText", (text, target) => {
        const di = (target as any)?.tooltipDataItem;
        const v = di?.valueY;
        if (v == null) return text;
            return `${this.formatData(v, metricType, false)}`;
        });
        series.stroke = sectionColor;
        series.fill = sectionColor;
        series.tensionX = 0.9;

        const bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.radius = 2;

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;
        chart.cursor.yAxis = valueAxis;
    }

    private getDataTypeFromColumn(columnName: string): string | null {

        const vm = this.getTemplateViewModel();
        const headers = vm?.headers?.() || [];

        for (const header of headers) {
            for (const sh of (header?.subHeaders || [])) {
                if (sh?.column === columnName) return sh.dataType || null;

                for (const subColumn of this.getSubColumnsForSubHeader(sh)) {
                    if (subColumn.column === columnName) return subColumn.dataType || null;
                }
            }
        }
        return null;
    }

    private populateSectionDropdown(selectId: string): void {
        const select = document.getElementById(selectId) as HTMLSelectElement | null;
        if (!select) return;

        const headers = this.getTemplateViewModel()?.headers?.() || [];
        select.innerHTML = "";

        for (const header of headers) {
            if (header?.hidden || !header?.name || this.getChartMetricsForSection(header.name).length === 0) {
                continue;
            }

            const opt = document.createElement("option");
            opt.value = header.name;
            opt.text = header.name;
            select.appendChild(opt);
        }
    }

    private populateMetricDropdown(sectionName: string, selectId: string): void {
        const select = document.getElementById(selectId) as HTMLSelectElement | null;
        if (!select) return;

        select.innerHTML = "";

        for (const metric of this.getChartMetricsForSection(sectionName)) {
            const opt = document.createElement("option");
            opt.value = metric.column;
            opt.text = metric.name;
            select.appendChild(opt);
        }
    }

    private getChartMetricsForSection(sectionName: string): Array<any> {
        const headers = this.getTemplateViewModel()?.headers?.() || [];
        const metrics: Array<any> = [];

        for (const header of headers) {
            if (header?.hidden || header?.name !== sectionName) {
                continue;
            }

            for (const subHeader of (header?.subHeaders || [])) {
                if (!this.isSubHeaderVisible(subHeader) || subHeader?.not_applicable) {
                    continue;
                }

                if (subHeader?.column) {
                    metrics.push({
                        column: subHeader.column,
                        name: this.getHeaderNameFromColumn(subHeader.column),
                    });
                }

                for (const subColumn of this.getSubColumnsForSubHeader(subHeader)) {
                    if (!subColumn?.column || subColumn?.not_applicable) {
                        continue;
                    }

                    metrics.push({
                        column: subColumn.column,
                        name: this.getHeaderNameFromColumn(subColumn.column),
                    });
                }
            }
        }

        return metrics;
    }

    private sectionHasMetric(sectionName: string, metricColumn: string): boolean {
        return this.getChartMetricsForSection(sectionName).some(metric => metric.column === metricColumn);
    }

    private getSectionNameFromColumn(columnName: string): string | null {
        const headers = this.getTemplateViewModel()?.headers?.() || [];

        for (const header of headers) {
            if (header?.hidden || !header?.subHeaders) {
                continue;
            }

            for (const subHeader of header.subHeaders) {
                if (subHeader?.column === columnName) {
                    return header.name || null;
                }

                for (const subColumn of this.getSubColumnsForSubHeader(subHeader)) {
                    if (subColumn?.column === columnName) {
                        return header.name || null;
                    }
                }
            }
        }

        return null;
    }

    private getSectionColor(sectionName: string): am4core.Color {

        switch (sectionName) {

            case "Revenue":
            case "Brand Revenue":
                return am4core.color("#1E88E5");

            case "Spend":
                return am4core.color("#8E24AA");

            case "Financial Performance":
            case "Vertical Revenue":
                return am4core.color("#2FA866");

            case "Funnel Visualization":
            case "Lead Economics":
            case "Revenue Metrics":
            case "Acquisition Metrics":
                return am4core.color("#C9A800");
        }

        return am4core.color("#1E88E5");
    }

    private disposeChart(chartId: string): void {
        const existing = this.leadgenCharts[chartId];
        if (existing) {
            existing.dispose();
            delete this.leadgenCharts[chartId];
        }
    }

    private disposeAllLeadgenCharts(): void {
        this.disposeChart("leadgen-revenue-chart");
        this.disposeChart("leadgen-spend-chart");
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/leadgen_template.ts